import { c as _c } from "react/compiler-runtime";
import type { ColumnFiltersState } from '@tanstack/react-table';
import { useMemo } from 'react';
import type { DashboardBorrowPositionsFilters } from '@/helpers/filter/table';
import type { BorrowPositionsTableRow } from '../config/BorrowPositionsTable.types';
interface DashboardBorrowPositionsFiltersProps {
  items: BorrowPositionsTableRow[];
  columnFilters: ColumnFiltersState;
}
export const useDashboardBorrowPositionsFilters = t0 => {
  const $ = _c(24);
  const {
    items,
    columnFilters
  } = t0;
  let t1;
  if ($[0] !== columnFilters) {
    t1 = columnFilters.find(_temp);
    $[0] = columnFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collateralFilter = t1;
  let t2;
  if ($[2] !== columnFilters) {
    t2 = columnFilters.find(_temp2);
    $[2] = columnFilters;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const loanFilter = t2;
  let t3;
  if ($[4] !== columnFilters) {
    t3 = columnFilters.find(_temp3);
    $[4] = columnFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const chainFilter = t3;
  let t4;
  if ($[6] !== collateralFilter) {
    t4 = collateralFilter ? collateralFilter.value as string[] : [];
    $[6] = collateralFilter;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== loanFilter) {
    t5 = loanFilter ? loanFilter.value as string[] : [];
    $[8] = loanFilter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== chainFilter) {
    t6 = chainFilter ? chainFilter.value as number[] : [];
    $[10] = chainFilter;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      collateralAssetIdsFilter: t4,
      loanAssetIdsFilter: t5,
      chainIdsFilter: t6
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const filters = t7;
  let t8;
  if ($[16] !== filters || $[17] !== items) {
    let t9;
    if ($[19] !== filters) {
      t9 = item => {
        const collateralSelector = item.market.collateralAsset ? `${item.market.chainId}:${item.market.collateralAsset.address.toLowerCase()}` : "";
        const withCollateralAssetFilter = filters.collateralAssetIdsFilter.length === 0 || filters.collateralAssetIdsFilter.includes(collateralSelector);
        const loanSelector = `${item.market.chainId}:${item.market.loanAsset.address.toLowerCase()}`;
        const withLoanAssetFilter = filters.loanAssetIdsFilter.length === 0 || filters.loanAssetIdsFilter.includes(loanSelector);
        const withChainIdFilter = !filters.chainIdsFilter?.length || filters.chainIdsFilter.includes(item.market.chainId);
        return withCollateralAssetFilter && withLoanAssetFilter && withChainIdFilter;
      };
      $[19] = filters;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t8 = items.filter(t9);
    $[16] = filters;
    $[17] = items;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const filteredItems = t8;
  let t9;
  if ($[21] !== filteredItems || $[22] !== filters) {
    t9 = {
      filters,
      filteredItems,
      itemsCount: filteredItems.length
    };
    $[21] = filteredItems;
    $[22] = filters;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
function _temp(f) {
  return f.id === "collateralAssetIds";
}
function _temp2(f_0) {
  return f_0.id === "loanAssetIds";
}
function _temp3(f_1) {
  return f_1.id === "chainIds";
}